'use client';

import { forwardRef, ButtonHTMLAttributes } from 'react';
import styles from './CloseButton.module.css';
import Icon from './Icon';

interface CloseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg';
}

// The glyph's own font-size per button size — was live via the `.{size} span` element-type
// selector (CSS Modules doesn't hash `span`), unaffected by D7's Icon migration; kept as the
// one source here since the glyph is now an <Icon size={…}> numeric escape, not CSS.
const ICON_PX: Record<'sm' | 'md' | 'lg', number> = { sm: 16, md: 20, lg: 24 };

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(({
  size = 'md',
  className = '',
  'aria-label': ariaLabel = 'Close',
  ...props
}, ref) => {
  return (
    <button
      ref={ref}
      className={[styles.closeButton, styles[size], className].filter(Boolean).join(' ')}
      type="button"
      aria-label={ariaLabel}
      {...props}
    >
      <Icon name="close" size={ICON_PX[size]} />
    </button>
  );
});

CloseButton.displayName = 'CloseButton';
export default CloseButton;
